import { Directive, ViewChild } from '@angular/core';
import { DocumentService } from 'src/app/_services/document.service';
import { ProposalService } from 'src/app/_services/proposal.service';
import { CollaboratorMetadata } from 'src/app/_types/lead.types';
import { getCollaboratorContractTypeLabel } from 'src/app/enums/business/collaborator-contract-type.enum';
import { getCollaboratorLPPPlanLabel } from 'src/app/enums/business/collaborator-lpp-plan.enum';
import { getCivilStatusLabel } from 'src/app/enums/civil-status.enum';
import { getSexEnumLabel } from 'src/app/enums/sex.enum';
import { getCountryName } from 'src/app/helpers/nationalities';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class CollaboratorMetadataComponentAbstract extends BaseMetadataComponent<CollaboratorMetadata> {
  getSexEnumLabel = getSexEnumLabel;

  getCivilStatusLabel = getCivilStatusLabel;

  getCollaboratorContractTypeLabel = getCollaboratorContractTypeLabel;

  getCollaboratorLPPPlanLabel = getCollaboratorLPPPlanLabel;

  getCountryName = getCountryName;

  constructor(
    proposalService: ProposalService,
    private readonly documentService: DocumentService
  ) {
    super(proposalService);
  }

  displayContractDetails(metadata?: CollaboratorMetadata) {
    return (
      metadata?.contractDetails &&
      (metadata.contractDetails.startDate ||
        metadata.contractDetails.contractType ||
        metadata.contractDetails.function ||
        metadata.contractDetails.occupancyRate !== undefined ||
        metadata.contractDetails.annualAvsSalary !== undefined ||
        metadata.contractDetails.multipleEmployers !== undefined ||
        metadata.contractDetails.thirteenthMonth !== undefined)
    );
  }

  displayPreviousLppDetails(metadata?: CollaboratorMetadata) {
    return (
      metadata?.previousLppDetails &&
      (metadata.previousLppDetails.pensionFund ||
        metadata.previousLppDetails.referenceNumber ||
        metadata.previousLppDetails.estimatedCreditAmount !== undefined ||
        metadata.previousLppDetails.firstName ||
        metadata.previousLppDetails.lastName ||
        metadata.previousLppDetails.email ||
        metadata.previousLppDetails.phone)
    );
  }

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  viewFile(key: string) {
    this.documentService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
